// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nu-5";
export var filledCircle = "_nu-4";
export var historyEntry = "_nu-3";
export var messageSideLeft = "_nu-1";
export var messageSideRight = "_nu-2";
export var orderTrackingCarouselWrapper = "_nu-6";
export var orderTrackingInfoContainer = "_nu-0";